import Mobiledoc from "mobiledoc-kit";
import tippy from "tippy.js";
import "tippy.js/dist/tippy.css"; // optional for styling
import MobiledocDOMRenderer from "mobiledoc-dom-renderer";
const renderer = new MobiledocDOMRenderer();

export default {
  data() {
    return {
      draft_value: undefined,
      ID: undefined,
      editorHasImages: undefined,
      editorTextContent: undefined,
      copyMobiledoc: undefined,
    };
  },
  computed: {
    editor() {
      return this.mode
        ? this.$root.editors.filter((editor) => {
            return editor.id === this.ID;
          })[0]?.editor
        : undefined;
    },
    getLocalStorageKey() {
      return "mobiledocdraft__" + this.ID;
    },
    isMobiledockEmpty() {
      if (!this.mode) {
        return true;
      }

      const isMobiledockEmpty =
        (!this.editorTextContent ||
          !this.editorTextContent.length ||
          this.editorTextContent.length < 2 ||
          !this.editorTextContent.replace(/\s/g, "").length) &&
        !this.editorHasImages;

      this.$root.$emit("updateIsMobiledocEmpty", isMobiledockEmpty);

      this.$debug(
        "MOBILEDOC EDITOR: " + isMobiledockEmpty ? "пусто" : "заполнено",
        "warning",
        isMobiledockEmpty
      );
      return isMobiledockEmpty;
    },
    validMobiledoc() {
      return this.copyMobiledoc && this.copyMobiledoc.atoms;
    },
    renderedText() {
      let result = "";
      if (this.validMobiledoc) {
        const rendered = renderer.render(this.copyMobiledoc);
        const div = document.createElement("div");
        div.appendChild(rendered.result);
        result = div.textContent;
      }
      return result;
    },
    rendered() {
      let result = "";
      if (this.validMobiledoc) {
        const rendered = renderer.render(this.copyMobiledoc);
        const div = document.createElement("div");
        div.appendChild(rendered.result);
        result = div.innerHTML;
      }
      return result;
    },
  },
  watch: {
    editors(editors) {
      this.$root.editors = editors;
    },
    editorTextContent(val) {
      this.$root.$emit("editorTextContentUpdated", val);
    },
    draft_value(val) {
      const action = this.isMobiledockEmpty ? "removeItem" : "setItem";
      localStorage[action](this.getLocalStorageKey, JSON.stringify(val));
    },
  },
  beforeDestroy() {
    this.$root.$off("addScreen", this.addScreenToMobileDocPrepare);
    this.$root.$off("clearMobiledocEditor", this.clearForm);
    this.$root.$off(
      "mobiledocEditorTriggerEnter",
      this.mobiledocEditorTriggerEnter
    );
    this.$root.$off(
      "mobiledocEditorTriggerClick",
      this.mobiledocEditorTriggerClick
    );
    this.checkClickEvents(true);
    if (this.$refs.editor) {
      this.$refs.editor.removeEventListener(
        "keydown",
        this.eventCheckerForAutoScrollMobiledocEditor
      );
    }
    this.$root.removeEditor(this.ID);
  },
  mounted() {
    this.copyMobiledoc = this.mobiledoc;
    if (this.mobiledoc && typeof this.mobiledoc === "string") {
      this.copyMobiledoc = {
        version: "0.3.0",
        atoms: [],
        cards: [],
        markups: [],
        sections: [[1, "p", [[0, [], 0, this.mobiledoc]]]],
      };
    }

    if (this.mobiledoc && this.mobiledoc.atoms) {
      this.copyMobiledoc = { ...this.mobiledoc };
      this.copyMobiledoc.version = "0.3.0";
    }

    renderer.options.unknownCardHandler = this.screenCardRenderHTMLonly;
    this.$root.$on("addScreen", this.addScreenToMobileDocPrepare);
    this.$root.$on("clearMobiledocEditor", this.clearForm);
    this.$root.$on(
      "mobiledocEditorTriggerEnter",
      this.mobiledocEditorTriggerEnter
    );
    this.$root.$on(
      "mobiledocEditorTriggerClick",
      this.mobiledocEditorTriggerClick
    );
    // this.$accessModule("mobiledoctext", this);
    if (this.mode) {
      this.$accessModule("editor", this);
    }

    this.ID = this.uuid || this.$root.rnd()(5);
    this.checkDrafts();
    this.checkClickEvents();
  },
  methods: {
    screenCardRenderHTMLonly(e) {
      return this.screenCardRender(e, true);
    },
    clearForm() {
      if (!this.mode) {
        return;
      }
      this.$nextTick(() => {
        this.draft_value = undefined;
        this.editor.run((postEditor) => {
          var postRange = new Mobiledoc.default.Range(
            this.editor.post.headPosition(),
            this.editor.post.tailPosition()
          );
          postEditor.deleteRange(postRange);
        });
      });
    },
    clickScreen(e) {
      this.$root.$emit(
        "showAnyImageInModal",
        e.target.src || e.target.parentElement.lastChild.src
      );
    },
    addScreenToMobileDocPrepare(src) {
      if (!this.mode) {
        return;
      }
      let img = document.createElement("img");
      img.src = src.info.publicUrl;
      img.onload = () => {
        this.addScreenToMobileDoc(src);
        img.remove();
      };
      img.onerror = () => {
        this.$notify({
          group: "loggedIn",
          type: "error",
          text: this.$t("Cannot loading screen -- adblock"),
        });
        img.remove();
      };
    },
    addScreenToMobileDoc(src) {
      if (!this.editor) {
        return;
      }

      this.$nextTick(() => {
        this.$refs.editor.focus();
      });

      setTimeout(() => {
        this.$refs.editor.focus();

        // this.mobiledocEditorTriggerEnter();

        window.currentScreen = src;
        let card = {
          name: "screen-image-in-doc",
          type: "dom",
          render: this.screenCardRender,
        };

        this.editor.cards.push(card);
        this.editor.insertCard("screen-image-in-doc");
      }, 100);

      setTimeout(() => {
        this.mobiledocEditorTriggerEnter();
        //   this.mobiledocEditorTriggerEnter();
      }, 100);

      setTimeout(() => {
        this.addTippyHandler();
        this.checkClickEvents();
      }, 500);
    },
    mobiledocEditorTriggerClick() {
      if (this.$refs.editor) {
        this.$refs.editor.click();
      }
    },
    mobiledocEditorTriggerEnter() {
      if (!this.$refs.editor) {
        return;
      }
      this.$refs.editor.dispatchEvent(
        new KeyboardEvent("keydown", {
          key: "Enter",
          code: "Enter",
          which: 13,
          keyCode: 13,
        })
      );
    },
    addTippyHandler() {
      tippy(".__remove" + this.ID, {
        theme: "light",
        content:
          '<div class="delete-screen-popup">' +
          '<div class="dash-text__16 dash-text__500">' +
          this.$t("Remove?") +
          "</div>" +
          '<div class="m-t"> ' +
          '<button class="delete-screen-popup__button no">' +
          this.$t("No") +
          "</button> " +
          '<button class="delete-screen-popup__button yes m-l">' +
          this.$t("Yes") +
          "</button> " +
          "</div>" +
          "</div>",
        allowHTML: true,
        trigger: "click",
        hideOnClick: false,
        onShow: (e) => {
          e.popper.getElementsByClassName("no")[0].onclick = e.hide;
          e.popper.getElementsByClassName("yes")[0].onclick = e.reference.click;
        },
        onClickOutside(instance, event) {
          instance.hide();
        },
        placement: "left",
      });
    },
    initEditor() {
      if (!this.mode) {
        return;
      }

      let val = null;

      if (this.mobiledoc && Object.keys(this.mobiledoc).length) {
        val = { mobiledoc: { ...this.mobiledoc, version: "0.3.0" } };
      } else if (
        this.draft_value &&
        this.draft_value.atoms &&
        this.draft_value.sections.length
      ) {
        val = {
          mobiledoc: this.draft_value,
        };
      } else {
        val = {
          mobiledoc: {
            version: "0.3.0",
            atoms: [],
            cards: [],
            markups: [],
            sections: [],
          },
        };
      }

      var options = {
        autofocus: true,
        placeholder: this.placeholder
          ? this.placeholder
          : this.$t("Comment placeholder"),
        ...val,
        unknownCardHandler: this.screenCardRender,
      };

      this.$root.addEditor({
        id: this.ID,
        editor: new Mobiledoc.Editor(options),
      });

      this.editor.didRender(() => {
        const draft = this.editor.serialize();

        this.editorHasImages =
          this.$refs.editor.innerHTML.indexOf("image-in-mobile-doc") !== -1;

        this.editorTextContent = this.$refs.editor.textContent;

        if (
          typeof draft !== "object" ||
          (draft.sections.length <= 1 && (draft.sections[2] || {}).length <= 3)
        ) {
          console.log("стерли, ничего не делаем");
        } else {
          this.draft_value = this.editor.serialize();
        }
      });
      this.editor.render(this.$refs.editor);
      this.mobiledocEditorTriggerClick();
      // this.mobiledocEditorTriggerEnter();
      this.$refs.editor.addEventListener(
        "keydown",
        this.eventCheckerForAutoScrollMobiledocEditor
      );

      this.checkClickEvents();
      this.addTippyHandler();
    },
    eventCheckerForAutoScrollMobiledocEditor(e) {
      const scrollCon = this.scrollCon
        ? this.$refs.editor.parentElement.parentElement
        : this.$refs.editor;

      const possibleScroll =
        (scrollCon.scrollTop * 100) / scrollCon.scrollHeight;

      if ((scrollCon && possibleScroll > 5) || scrollCon.scrollHeight < 400) {
        scrollCon.scrollTop = scrollCon.scrollHeight;
      }
    },
    checkDrafts() {
      if (this.mobiledoc && this.validMobiledoc) {
        this.draft_value = {
          ...this.copyMobiledoc,
        };
        return;
      }
      const draft = localStorage.getItem(this.getLocalStorageKey);
      if (draft) {
        try {
          this.draft_value = JSON.parse(draft);
          this.$debug("остался драфт, подгружаем его", "warning");
        } catch (error) {
          this.$debug("Не удалось подгрузить драфт. битый json", "error", {
            draft: draft,
            error: error,
          });
        }
      }
    },
    checkClickEvents(destroy) {
      const screens = [...document.getElementsByClassName("__img" + this.ID)];
      screens.map((screen) => {
        const action = destroy ? "removeEventListener" : "addEventListener";
        screen[action]("click", this.clickScreen);
      });
    },
    screenCardRender(e, simple) {
      if (!window.currentScreen && !e.payload.src) {
        this.$notify({
          group: "loggedIn",
          type: "error",
          text: this.$t("Cannot loading screen -- adblock"),
        });
        return;
      }

      if (window.currentScreen) {
        //добавление карточки. сохранение publicUrl в payload для последующих рендеров
        e.env.save({
          src: window.currentScreen.info.publicUrl,
          key: window.currentScreen.screen,
        });
      }

      const random = this.$root.rnd()(5);

      let img = document.createElement("img");
      img.classList.add("image-in-mobile-doc--img");
      img.classList.add("__img" + this.ID);
      img.classList.add(random);

      // img.onclick = this.clickScreen; //клик хук
      img.src = window.currentScreen
        ? window.currentScreen.info.publicUrl
        : e.payload.src; //если есть src - функция вызвана по кнопке добавить скриншот. если его нет берется payload в котором уже лежит publicUrl

      img.onerror = (e) => {
        const image = document.getElementsByClassName(random)[0];
        if (image) {
          image.src = "/404Serie.png";
        }
      };

      let icon = document.createElement("i");
      icon.classList.add("image-in-mobile-doc--fullscreen");
      icon.classList.add("__img" + this.ID);
      icon.classList.add("fa-light");
      icon.classList.add("fa-arrow-up-right-and-arrow-down-left-from-center");

      let deleteicon = document.createElement("i");
      deleteicon.classList.add("image-in-mobile-doc--remove");
      deleteicon.classList.add("__remove" + this.ID);
      deleteicon.classList.add("fa-light");
      deleteicon.classList.add("fa-trash");
      deleteicon.setAttribute("data-id", img.src);
      deleteicon.click = e.env.remove;

      let inner = document.createElement("div");
      inner.classList.add("image-in-mobile-doc__inner");
      inner.appendChild(icon);
      if (!simple) {
        inner.appendChild(deleteicon);
      }
      inner.appendChild(img);

      let div = document.createElement("div");
      div.classList.add("image-in-mobile-doc");
      div.appendChild(inner);

      window.currentScreen = undefined;

      return div;
    },
  },
};
